import { render } from "./progress-circle-material.vue?vue&type=template&id=e8dbe8ba&ts=true"
import script from "./progress-circle-material.vue?vue&type=script&lang=ts"
export * from "./progress-circle-material.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__